import $ from 'zepto';
var tpl = require('../tpl/share.tpl');
// var util = require('../common/util.js');
import util from '../common/util.js';

var title, link, desc, imgUrl,
	ua = navigator.userAgent;

var UA_IOS_REG = /\b(iPad|iPhone|iPod)\b.*? OS ([\d_]+)/;
var UA_ANDROID_REG = /\bAndroid([^;]+)/;

var isIOS = UA_IOS_REG.test(ua);

function append() {
	var shareText;
	shareText = '点击右上角<br>发送给朋友or分享朋友圈哟';
	if ($('#share_pop').length == 0) {
		$(tpl).appendTo('body');
	}
	$('#share_pop .text_share').html(shareText);
	$('#share_pop').show();
	$('#share_pop').unbind().click(function(event) {
		$('#share_pop').hide();
		return false;
	});
}

function initShareData(opt) {
	var opt = opt || {};
	var defaultSharePic = getUrl() + 'img/share.jpg';
	title = opt.title || document.title,
		link = opt.link || location.href,
		desc = opt.desc || '',
		imgUrl = opt.imgUrl || defaultSharePic;
}

var Share = initShareData;
//获取当前目录url
function getUrl() {
	var href = location.href,
		index = href.indexOf('?'),
		defaultSharePic;
	if (index != -1) {
		href = href.substring(0, index);
	}
	//剔除index.html
	index = href.indexOf('index.html');

	if (index != -1) {
		href = href.substring(0, index);
	}

	if (!/\/$/.test(location.href)) {
		href = href + '/';
	}
	return href;

}

//分享到微信
function shareToWX(opt) {
	var typeUrl, appId;

	if (!util.isWeixin()) {
		return false;
	}
	//區分网游和会员
	typeUrl = domainList.dyactive + '/weixin_huiyuan/server.php?type=jweixinSign';
	appId = 'wxffca8b088e4134ac';

	$.jsonp(typeUrl + '&url=' + encodeURIComponent(location.href.split('#')[0]) + '&time=' + new Date().getTime(), function(rs) {
		if (rs.result == 0) {
			wx.config({
				debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
				appId: appId, // 必填，公众号的唯一标识
				timestamp: rs.data.timestamp, // 必填，生成签名的时间戳
				nonceStr: rs.data.nonceStr, // 必填，生成签名的随机串
				signature: rs.data.signature, // 必填，签名，见附录1
				jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
			});
			wx.ready(function() {
				wx.onMenuShareTimeline({
					title: title, // 分享标题
					link: link, // 分享链接
					imgUrl: imgUrl, // 分享图标
					success: function() {

					},
					cancel: function() {

					}
				});

				wx.onMenuShareAppMessage({
					title: title, // 分享标题
					desc: desc, // 分享描述
					link: link, // 分享链接
					imgUrl: imgUrl, // 分享图标
					type: '', // 分享类型,music、video或link，不填默认为link
					dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
					success: function() {

					},
					cancel: function() {

					}
				});
			});
		} else {
			wx.error(function(res) {
				console.log(res);
			});
		}
	})
}

function shareToOldSL() {
	window.share.displayUmengShareBtn(JSON.stringify({
		url: link,
		wxUrl: link,
		imgUrl: imgUrl,
		title: title,
		type: 'activity',
		content: desc
	}));
}

//分享到ios手雷
function shareToIOSSL() {
	//防止ios过长，微博不能分享
	var shareLink = link;
	var length = link.indexOf('?');

	if (length != -1 && link == location.href) {
		shareLink = shareLink.substring(0, length);
	}
	//防止#被转码，折中去掉
	length = link.indexOf('#');

	if (length != -1) {
		shareLink = shareLink.substring(0, length);
	}

	var shareClient = {};
	shareClient.url = shareLink;
	shareClient.imgUrl = imgUrl;
	shareClient.title = desc;
	shareClient.type = 'activity';
	shareClient.headline = title;
	var param = '{"jsondata":"' + encodeURIComponent(JSON.stringify(shareClient)) + '"}';
	loadURL("xlscheme://clienthost/showUmengShareBtn?jsondata=" + encodeURIComponent(param));
}

//分享到新版手雷
function shareToNewSL(data) {
	client.data.shareTo({
		'sharePlatform': 1,
		'shareHeadline': title,
		'shareImageUrl': imgUrl,
		'shareUrl': link
	}, function(response) {
		var result = response.result;
		if (result == 0) { //分享成功
			/*if (typeof window.ACTCONFIG.successCallback == 'function') {
				window.ACTCONFIG.successCallback();
			}*/
		} else if (result == 2) { //分享取消
			/*if (typeof window.ACTCONFIG.cancleCallback == 'function') {
				window.ACTCONFIG.cancleCallback();
			}*/
		}
	})
}

//直接打开新浪微博分享
function shareSina(data) {
	var openUrl = 'http://service.weibo.com/share/share.php?url=' + encodeURIComponent(link) + '&title=' + encodeURIComponent(title) + '&pic=' + encodeURIComponent(imgUrl);
	window.open(openUrl);

}

//友盟分享
function loadURL(url) {
	var iFrame;
	iFrame = document.createElement("iframe");
	iFrame.setAttribute("src", url);
	iFrame.setAttribute("style", "display:none;");
	iFrame.setAttribute("height", "0px");
	iFrame.setAttribute("width", "0px");
	iFrame.setAttribute("frameborder", "0");
	document.body.appendChild(iFrame);
	// 发起请求后这个iFrame就没用了，所以把它从dom上移除掉
	iFrame.parentNode.removeChild(iFrame);
}

initShareData();
shareToWX();
var Events = {
	'document|#act_wx_share,.act_wx_share,.act_share|click': function() {
		var needLogin = $(this).attr('needlogin');
		if (needLogin == 1 && !haslogin()) {
			login();
			return false;
		}
		var shareData = $(this).attr('data-shareinfo');
		if (shareData) {
			shareData = JSON.parse(shareData);
			initShareData(shareData);
		}

		if (util.isWeixin()) {
			append();
			shareToWX();
		} else if (util.isShouLei()) { //新版手雷
			shareToNewSL();
		} else if (window.share && window.share.displayUmengShareBtn) { //判断旧版手雷
			shareToOldSL();
		} else if (isIOS) {
			shareToIOSSL();
		} else {
			shareSina();
		}
	}
}
Share.shareToWX = shareToWX;
Share.initShareData = initShareData;
util.initEvents(Events);
module.exports = Share;



// WEBPACK FOOTER //
// ./src/tools/share.js